import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { docRestrictionsApi } from '../../constants/doc-restriction-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
  providedIn: 'root'
})
export class DocRestrictionsService {
  permissions_entity = permissionEntity;
  
  constructor(
    private httpClientService: HttpClientService,
    private _permissionPipe: PermissionsPipe // dont remove this
  ) {}

    getUploadDocRestrict(pagination: PaginationType, search?:string): Observable<any> {
      let query = '?';
      if (search) {
        query += `${search}`;
      }
      query += userParams.call(this, this.permissions_entity.modules.document_restrictions);
      query += `skip=${pagination.skip}&limit=${pagination.limit}`;
      return this.httpClientService.get(`${docRestrictionsApi.getUploadDocRestrict}${query}`);
    }

    postUploadDocRestrict(payload: any): Observable<any> {
        return this.httpClientService.post(
          docRestrictionsApi.addUploadDocRestrict,
            payload
        );
    }

    editUploadDocRestrict(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(`${docRestrictionsApi.updateUploadDocRestrict}?uploadDocResctrictId=${id}`, payload);
    }

    deleteUploadDocRestrict(id: any): Observable<any> {
        return this.httpClientService.delete(`${docRestrictionsApi.deleteUploadDocRestrict}?Id=${id}`);
    }
}
